import { render, staticRenderFns } from "./TestimonialEdit.vue?vue&type=template&id=1c4531a9"
import script from "./TestimonialEdit.vue?vue&type=script&lang=js"
export * from "./TestimonialEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports